import {
  DEVICES_IMPORT_OPEN_MODAL,
  DEVICES_IMPORT_CLOSE_MODAL,
  DEVICES_IMPORT_PROCESS_CSV,
  DEVICES_IMPORT_PROCESS_CSV_RESULT,
  DEVICES_IMPORT_PROCESS_CALAMP_CSV,
  DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT,
  DEVICES_IMPORT_PROCESS_QUECLINK_CSV,
  DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT,
  DEVICES_IMPORT_PROCESS_PUI_CSV,
  DEVICES_IMPORT_GET_DEVICE_MODEL,
  DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT,
  DEVICES_IMPORT_LOAD_PHONE_NUMBERS,
  DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT,
  DEVICES_IMPORT_SAVE,
  DEVICES_IMPORT_SAVE_RESULT,
  DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO,
  DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT,
  DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO,
  DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT,
  DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV,
  DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT,
  DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV,
  DEVICES_IMPORT_PROCESS_TELITEK_CSV,
  DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV,
  DEVICES_IMPORT_PROCESS_ZONAR_CSV,
  DEVICES_IMPORT_PROCESS_GENX_CSV,
  DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV,
  DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV,
  DEVICES_IMPORT_PROCESS_M2MD_CSV,
  DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV
} from 'Redux/actionTypes';

export const devicesImportShow = () => ({
  type: DEVICES_IMPORT_OPEN_MODAL
});

export const devicesImportHide = () => ({
  type: DEVICES_IMPORT_CLOSE_MODAL
});

export const devicesImportProcessCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvResult = (data) => ({
  type: DEVICES_IMPORT_PROCESS_CSV_RESULT,
  payload: data
});

export const devicesImportProcessCsvQueclinkAndTopFly = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_QUECLINK_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvTelitek = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_TELITEK_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvQueclinkResult = (data) => ({
  type: DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT,
  payload: data
});

export const devicesImportProcessCalampCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_CALAMP_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCalampCsvResult = (data) => ({
  type: DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT,
  payload: data
});

export const devicesImportProcessPUICsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_PUI_CSV,
  payload: { cvsData }
});

export const devicesImportGetDeviceModel = (deviceModelId) => ({
  type: DEVICES_IMPORT_GET_DEVICE_MODEL,
  payload: { deviceModelId }
});

export const devicesImportGetDeviceModelResult = (data) => ({
  type: DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT,
  payload: data
});

export const devicesImportLoadPhoneNumbers = (devices) => ({
  type: DEVICES_IMPORT_LOAD_PHONE_NUMBERS,
  payload: { devices }
});

export const devicesImportLoadPhoneNumbersResult = (data) => ({
  type: DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT,
  payload: data
});

export const devicesImportSave = (manufacturer, account, simProviderAccount, reference, devices, timezoneId, tagIds) => ({
  type: DEVICES_IMPORT_SAVE,
  payload: { manufacturer, account, simProviderAccount, reference, devices, timezoneId, tagIds}
});

export const devicesImportSaveResult = (data) => ({
  type: DEVICES_IMPORT_SAVE_RESULT,
  payload: { data }
});

export const devicesImportGetCalampDevicesInfo = (data) => ({
  type: DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO,
  payload: { data }
});

export const devicesImportGetCalampDevicesInfoResult = (data) => ({
  type: DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT,
  payload: data
});

export const devicesImportGetGeometrisDevicesInfo = (data) => ({
  type: DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO,
  payload: { data }
});

export const devicesImportGetGeometrisDevicesInfoResult = (data) => ({
  type: DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT,
  payload: data
});

export const devicesImportProcessGeometrisCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV,
  payload: { cvsData }
});

export const devicesImportProcessGeometrisCsvResult = (data) => ({
  type: DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT,
  payload: data
});

export const devicesImportProcessCerebrumXCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV,
  payload: { cvsData }
});

export const devicesImportProcessPacificTrackCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV,
  payload: { cvsData }
});

export const devicesImportProcessZonarCsv = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_ZONAR_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvGenX = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_GENX_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvDigitalMatters = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvLightMetrics = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvM2MD = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_M2MD_CSV,
  payload: { cvsData }
});

export const devicesImportProcessCsvSmartWitness = (cvsData) => ({
  type: DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV,
  payload: { cvsData }
});
